import { createSelector } from 'reselect';
import { getIsLoadingServiceByParams as getIsLoadingServiceByParamsUtil } from '../../../utils';
export const getLoadingServiceTypesState = (state) => state.loadingServiceParams;
export const getIsLoadingServiceByParams = (params, loadingParamKeys = ['subType', 'type']) => createSelector(getLoadingServiceTypesState, loadingServicesTypesState => getIsLoadingServiceByParamsUtil(loadingServicesTypesState, params, loadingParamKeys));
